/* @flow */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type TypeForm from 'forms/_.extend';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';

import endpoints from 'api/endpoints';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  costCenter: Object,
  form: TypeForm,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveProjectsForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, costCenter, form }: TypeProps = this.props;

    const getChildData: Function = (child: string, val: string) => {
      return typeof costCenter[child] === 'undefined' ? null : costCenter[child][val];
    };

    const costCenterDetails: Array<Array> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:cost_centers.labels.code'), costCenter.code],
      [t('general:cost_centers.labels.name'), costCenter.name],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:cost_centers.labels.details')}
          >
            <ActionDrawerTable data={costCenterDetails} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('removeProjects.projectIds')}
            type="check"
            heading={form.$('removeProjects').label}
            endpoint={`${endpoints.costCenter}/${costCenter.id}/projects-dropdown`}
            enableSearch={true}
            searchKeys={['code', 'name']}
            // exclude={costCenter.projects.map((cc: Object) => (cc.id))}
            customResponse={(resp: Object) => {
              return resp;
            }}
            primaryLiteral={(item: Object) => {
              return `${item.code} - ${item.name}`;
            }}
          />
          <br />
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.reasons.why_remove_multiple')}
          >
            <div className={styles['form-group']}>
              <ElectroTextField
                field={form.$('removeProjects.reason')}
                props={{
                  multiline: true,
                  rows: 3,
                }}
              />
            </div>
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.remove_projects')} />
      </React.Fragment>
    );
  }
}
